(() => {
  const updateLink = (link, variantId, variantTitle) => {
    const productUrl = new URL(link.dataset.msUrl);
    if (variantId) productUrl.searchParams.set('variant', variantId);
    const option = variantTitle && variantTitle !== 'Default Title' ? ` (${variantTitle})` : '';
    const message = link.dataset.msMessage
      .replace('__PRODUCT__', () => link.dataset.msProduct + option)
      .replace('__URL__', () => productUrl.href);
    link.href = `https://wa.me/6596424069?text=${encodeURIComponent(message)}`;
  };
  const updateCard = (card) => {
    const link = card?.querySelector('.ms-flexa-whatsapp');
    if (!link) return;
    const selected = card.querySelector('input[data-variant-id]:checked');
    const title = selected?.labels?.[0]?.textContent.trim();
    updateLink(link, selected?.dataset.variantId, title);
  };
  document.addEventListener('variant:change', (event) => {
    const { variant } = event.detail || {};
    const formId = event.target.closest('form')?.getAttribute('id');
    if (!formId || !variant) return;
    document.querySelectorAll('.ms-flexa-whatsapp[data-ms-form]').forEach((link) => {
      if (link.dataset.msForm !== formId) return;
      link.dataset.msVariantId = variant.id;
      link.dataset.msVariantTitle = variant.title;
      updateLink(link, variant.id, variant.title);
    });
  });
  document.addEventListener('change', (event) => {
    updateCard(event.target.closest('product-card[data-ms-flexa]'));
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a.ms-flexa-whatsapp');
    if (!link) return;
    if (link.dataset.msForm) {
      updateLink(link, link.dataset.msVariantId, link.dataset.msVariantTitle);
    } else {
      updateCard(link.closest('product-card[data-ms-flexa]'));
    }
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target.closest('.ms-flexa-purchase')) event.preventDefault();
  });
})();
